var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfImg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 144,
    viewBox: "0 0 201 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1464_4349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.343 99.5001C144.343 104.92 139.953 109.31 134.533 109.31H75.6528L56.0228 128.94V50.4301C56.0228 45.0101 60.4128 40.6201 65.8328 40.6201H134.533C139.953 40.6201 144.343 45.0101 144.343 50.4301V99.5001Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8047 27.0554L55.0355 28.095C52.661 28.75 50.2051 27.356 49.5502 24.9815L44.5035 6.68469C43.8486 4.31017 45.2426 1.85431 47.6171 1.19936L51.3863 0.159722C53.7609 -0.495222 56.2167 0.89877 56.8717 3.27329L61.9183 21.5701C62.5733 23.9446 61.1793 26.4005 58.8047 27.0554ZM12.6934 10.4294L10.2813 13.5068C8.7618 15.4454 9.10155 18.2488 11.0402 19.7683L36.1783 39.4721C38.117 40.9916 40.9204 40.6519 42.4399 38.7132L44.852 35.6359C46.3715 33.6973 46.0318 30.8939 44.0931 29.3743L18.955 9.67058C17.0164 8.15105 14.213 8.49079 12.6934 10.4294ZM13.7292 53.268L14.4034 57.1194C14.8282 59.5457 17.1394 61.1682 19.5657 60.7435L38.2614 57.4705C40.6877 57.0457 42.3102 54.7345 41.8855 52.3082L41.2112 48.4568C40.7865 46.0305 38.4752 44.4079 36.0489 44.8327L17.3533 48.1057C14.927 48.5304 13.3044 50.8417 13.7292 53.268Z",
    fill: "#38A6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3431 88.1498C96.3431 87.5798 96.4531 87.0398 96.6631 86.5498C96.8731 86.0598 97.1731 85.6298 97.5431 85.2598C97.9131 84.8898 98.3631 84.5998 98.8731 84.3898C99.3831 84.1798 99.9431 84.0698 100.543 84.0698C101.143 84.0698 101.683 84.1798 102.193 84.3898C102.703 84.6098 103.153 84.8998 103.533 85.2598C103.913 85.6298 104.213 86.0598 104.433 86.5498C104.643 87.0398 104.753 87.5798 104.753 88.1498C104.753 88.7198 104.643 89.2598 104.433 89.7598C104.213 90.2598 103.923 90.6998 103.533 91.0598C103.153 91.4298 102.703 91.7098 102.193 91.9198C101.683 92.1298 101.133 92.2298 100.543 92.2298C99.9531 92.2298 99.3831 92.1298 98.8731 91.9198C98.3631 91.7098 97.9231 91.4298 97.5431 91.0598C97.1731 90.6898 96.8731 90.2598 96.6631 89.7598C96.4531 89.2598 96.3431 88.7198 96.3431 88.1498ZM104.083 57.0898V70.7598C104.083 72.2298 103.993 73.6798 103.823 75.1198C103.643 76.5598 103.413 78.0298 103.133 79.5298H98.1131C97.8231 78.0298 97.5931 76.5598 97.4231 75.1198C97.2431 73.6798 97.1631 72.2298 97.1631 70.7598V57.0898H104.093H104.083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_4349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 144,
    fill: "white",
    transform: "translate(0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfImg51);
export default __webpack_public_path__ + "static/media/pf_img5_1.42144cd388b3ac120283524407d3db89.svg";
export { ForwardRef as ReactComponent };